import { rulesService } from '../../services'

const defaultState = {
  rules: []
}

const getters = {
  rules: state => {
    return state.rules
  }
}

const actions = {
  async fetchRules({ commit }) {
    await rulesService.getRules().then(response => {
      commit('setRules', { response })
    })
  }
}

const mutations = {
  setRules(state, rules) {
    state.rules = rules.response
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
